'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isRegexMatch = isRegexMatch;
exports.safetyWrapper = safetyWrapper;
exports.bind = bind;
exports.extend = extend;
exports.hasKeys = hasKeys;
exports.merge = merge;
exports.isString = isString;
exports.isNumeric = isNumeric;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.initializeQueue = initializeQueue;
exports.validateQueueSize = validateQueueSize;
exports.validateQueueInterval = validateQueueInterval;

var _queueTypes = require('./queueTypes');

var _queueTypes2 = _interopRequireDefault(_queueTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isRegexMatch(regx, str) {
    if (new RegExp(regx).exec(str)) {
        return true;
    }

    return false;
}

/**
 * Wrap object in try catch to prevent unhandled errors from escaping.
 * @param object
 */
function safetyWrapper(object) {
    var name = void 0;
    var method = void 0;

    var wrapper = function wrapper(n, m) {
        var _this = this,
            _arguments = arguments;

        return function () {
            try {
                return m.apply(_this, _arguments);
            } catch (ex) {
                // continue regardless of error
            }
        };
    };

    for (name in object) {
        if (object.hasOwnProperty(name)) {
            method = object[name];
            if (typeof method === 'function') {
                object[name] = wrapper(name, method);
            }
        }
    }
}

function bind(fn, object) {
    var _arguments2 = arguments;

    return function () {
        return fn.apply(object, _arguments2);
    };
}

function extend(destination, source) {
    return source.map(function (property) {
        return destination[property];
    });
}

function hasKeys(obj) {
    var key = void 0;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            return true;
        }
    }
    return false;
}

function merge(context, defaultConfig, newConfig) {
    _extends(context, defaultConfig, newConfig);
}

function isString(string) {
    return string && typeof string === 'string';
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

function isObject(object) {
    return object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object';
}

function initializeQueue(type) {
    if (!type || !_queueTypes2.default[type]) {
        return _queueTypes2.default['non-persistent']();
    }

    return _queueTypes2.default[type]();
}

function validateQueueSize(size, defaultSize) {
    return isNumeric(size) && size > 0 ? size : defaultSize;
}

function validateQueueInterval(interval, defaultInterval) {
    return isNumeric(interval) && (interval >= 1000 || interval === 0) ? interval : defaultInterval;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/helpers.js
// module id = 106
// module chunks = 0